module.exports = __webpack_public_path__ + "img/94a877e9-5744-47a2-babd-f4c8cb1c4cb0.webp.ce8d370b.jpg";